﻿function onChangeFilters(event) {
    var currentDropdown = ($(this).attr("name"));
    if (currentDropdown == "ManufacturerId") {
        $.get("/cap-manufacturer-url/" + $(this).val(), function (response) {
            $("#ManufacturerName").val(response);
            window.updateResults();
        });
    }
}

function getData() {
    var manufacturerId = $('#ManufacturerId').val();
    var manufacturerName = $("#ManufacturerName").val();
    return {
        ManufacturerId: manufacturerId,
        ManufacturerName: manufacturerName
    };
}

function buildUpQueryString(data) {
    return "?Manufacturer=" + data.ManufacturerName;
}

function updateResultsLogic() {
    var data = getData();
    History.pushState(data, $('title').html(), location.pathname + buildUpQueryString(data));
}


function reloadQuery() {
    var State = History.getState();
    $.ajaxSetup({cache: false});
    $.get('/car-launch-calendar/query', State.data, function (response) {
        $('#car-launch-calendar-query-container').replaceWith(response);
    });
}

function markAsLoading() {
    $('#car-launches-results-container').text('').html('<div class="d-flex justify-content-center"><div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div></div>');
}


export function setupCarLaunchCalendar() {
    //dropdown changes
    $(document).on('change', '[data-car-launch-calendar] select', onChangeFilters);
    if ($('[data-car-launch-calendar]').length) {

        window.updateResults = function () {
            updateResultsLogic();
        }
// Bind to StateChange Event
        //History.Adapter.bind(window, 'statechange', function () { // Note: We are using statechange instead of popstate#
        //    markAsLoading();
        //    reloadQuery();
        //    var State = History.getState();
        //    setTimeout(
        //        function () {
        //            $.get('/car-launch-calendar/results', State.data, function (response) {
        //                $('#car-launches-results-container').replaceWith(response);
        //            });
        //        }, 500);

        //});

    }
}

//(function ($) {
//    function getForm() {
//        return $("[data-car-launch-calendar-form]");
//    }

//    function submitForm() {
//        var form = getForm();
//        form.submit();
//    }

//    $(function () {
//        $(document).on("change", "#Year", submitForm);

//    });
//})(jQuery);